var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('TopNav'),_c('Carousel'),_c('SectionHot'),_c('Product'),_c('Free'),_c('Process'),_c('Service'),_c('Parnter'),_c('Set'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }